module.exports = __webpack_public_path__ + "static/ogImage-679e0191a3ebe99064c44b0e3107500d.jpg";